import a from "./td-longtail-vue-components28.js";
import n from "./td-longtail-vue-components29.js";
import i from "./td-longtail-vue-components32.js";
import s from "./td-longtail-vue-components6.js";
import l from "./td-longtail-vue-components5.js";
import o from "./td-longtail-vue-components9.js";
/* empty css                              */
import c from "./td-longtail-vue-components98.js";
const m = {
  name: "BannerTeaser",
  components: {
    PictureElement: o,
    GridColumn: n,
    GridRow: a,
    Prices: i,
    Heading: s,
    Paragraph: l
  },
  props: {
    backgroundColor: { type: String, default: "" },
    imageXs: { type: String, default: "" },
    imageSm: { type: String, default: "" },
    imageMd: { type: String, default: "" },
    // Fallback IE11 default
    imageLg: { type: String, default: "" },
    imageXl: { type: String, default: "" },
    alt: { type: String, default: "" },
    lazy: { type: Boolean },
    theme: {
      type: String,
      default: void 0,
      validator(r) {
        return ["light", "dark", "primary", void 0].includes(r);
      }
    },
    isPrice: { type: String, default: "" },
    wasPrice: { type: String, default: "" },
    columnSm: { type: Number, default: 6 },
    columnMd: { type: Number, default: 6 },
    columnLg: { type: Number, default: null },
    columnXl: { type: Number, default: null },
    isContainer: { type: Boolean },
    alignV: {
      type: String,
      default: "center",
      validator(r) {
        return ["center", "end", "start"].includes(r);
      }
    }
  },
  computed: {
    bgColor() {
      return this.backgroundColor ? `background-color: ${this.backgroundColor}` : "";
    },
    classes() {
      const r = [];
      return r.push("banner-teaser"), this.theme && r.push(`text--${this.theme}`), this.alignV && r.push(`banner-teaser--v-align-${this.alignV}`), r;
    },
    containerClass() {
      return this.isContainer ? "banner-teaser__container--active" : null;
    },
    hasPrice() {
      return !!(this.isPrice || this.wasPrice);
    }
  }
};
var u = function() {
  var e = this, t = e._self._c;
  return t("div", { class: e.classes, style: e.bgColor }, [t("div", { staticClass: "banner-teaser__background" }, [e._t("background", function() {
    return [t("PictureElement", { attrs: { src: e.imageXs, "src-sm": e.imageSm, "src-md": e.imageMd, "src-lg": e.imageLg, lazy: e.lazy, alt: e.alt } })];
  })], 2), t("div", { staticClass: "banner-teaser__container", class: e.containerClass }, [t("grid-row", { attrs: { "align-v": "center" } }, [t("grid-column", { attrs: { sm: e.columnSm, md: e.columnMd, lg: e.columnLg, xl: e.columnXl } }, [e.$slots.heading ? t("heading", { attrs: { tag: "h3", size: "md", "text-uppercase": "" } }, [e._t("heading")], 2) : e._e(), e.$slots.paragraph ? t("paragraph", [e._t("paragraph")], 2) : e._e(), e._t("default"), e.hasPrice ? t("prices", { staticClass: "banner-teaser__prices", attrs: { "is-price": e.isPrice, "was-price": e.wasPrice } }) : e._e(), e._t("contentFooter")], 2), e.$slots.contentHero ? t("grid-column", { attrs: { sm: "", md: "", lg: "" } }, [e._t("contentHero")], 2) : e._e()], 1)], 1)]);
}, d = [], g = /* @__PURE__ */ c(
  m,
  u,
  d,
  !1,
  null,
  "cc1b9e56"
);
const v = g.exports;
export {
  v as default
};
